import TreeNode from "@gtmhub/shared/tree-renderer/tree-node";

export default class OrganizationTreeNode extends TreeNode {
  /**
   * create
   * On the Organizaion Chart page, we rely on Angular to render apply styles to the nodes. We only use
   * the tree to read the node dimensions, calcualate their positions not to overlap and apply them.
   * For this reason, we do not create any HTML, but rather just find the respective nodes in the DOM
   * and pass them through to the geometry algorithms in the core tree.
   *
   * @param {void}
   * @returns {HTMLDivElement}
   */
  protected create(): HTMLDivElement {
    const node = document.getElementById(this.htmlId) as HTMLDivElement;
    if (!node) {
      throw new Error(
        `Could not create an OrganizationTreeNode from HTML Node with id: "${this.htmlId}". No such node in the DOM. Please, make sure Angular has rendered it.`
      );
    }

    return node;
  }

  /**
   * renderIn
   * As explained above, we are not supposed to render any elements, but reuse the ones created by Angular.
   * Hence, we allow the base renderIn() function to apply the "tree-node" class and read the node dimensions,
   * but not allow it to modify the DOM.
   */
  public renderIn(): void {
    super.renderIn({ append: () => null } as HTMLElement);
  }

  /**
   * removeAllFrom
   * Clears all nodes from the given drawing container. In this case, since we have not rendered anything,
   * we just clear the styles modifications we did in renderIn().
   *
   * @param {HTMLElement} drawingContainer
   * @return {void}
   */
  public static removeAllFrom(drawingContainer: HTMLElement): void {
    Array.from(drawingContainer.querySelectorAll(`.${TreeNode.htmlClass}`))?.forEach((n: HTMLElement) => (n.style.transform = ""));
  }
}
